module.exports = __webpack_public_path__ + "img/time_small.7f6b2b7c.svg";